export default __webpack_public_path__ + "static/consistent-header-logged-in-53f2cf96d136b157a63e6937f8673a88.png";